import { AlbumIcon, ArrowNarrowRightIcon } from 'assets/icons';
import { MemberAvatar } from 'common/member-avatar';
import styles from './prompts-section.module.scss';

interface PromptCardProps {
  question: string;
  // Who asked (shown with an avatar above the question).
  askedBy: string;
  // The album an answer is saved in (shown as a badge next to who asked);
  // none for prompts that aren't in an album of the user's own.
  albumName?: string;
  // Opens the "Respond with" menu just below the card.
  onRespond: (anchor: DOMRect) => void;
}

// Figma: GS UI / Design System, Memory prompt card (node 32482:208234).
export const PromptCard = ({
  question,
  askedBy,
  albumName,
  onRespond,
}: PromptCardProps) => (
  <button
    type="button"
    className={styles.card}
    onClick={(e) => onRespond(e.currentTarget.getBoundingClientRect())}
    aria-haspopup="menu"
  >
    <span className={styles.cardContent}>
      <span className={styles.cardHeader}>
        <span className={styles.askedBy}>
          <MemberAvatar name={askedBy} size={24} className={styles.avatar} />
          <span className={styles.askedByName}>{askedBy}</span>
        </span>
        {albumName && (
          <span className={styles.albumBadge}>
            <AlbumIcon className={styles.albumIcon} />
            <span className={styles.albumName}>{albumName}</span>
          </span>
        )}
      </span>
      <span className={styles.question}>{question}</span>
    </span>
    <span className={styles.respond}>
      Respond
      <ArrowNarrowRightIcon />
    </span>
  </button>
);
